// types
import { AiChatContext } from './types'

// Scopes the persisted conversation selection so that different views/records don't share it
export const getContextKey = (context: AiChatContext): string =>
  context.type === 'riskView' ? `riskView:${context.riskViewId}` : `risk:${context.riskId}`

// Both `aiConversations.filter` and `sendAiMessage.input` are scoped by the same id
export const getContextVariables = (context: AiChatContext): { riskViewId: string } | { riskId: string } =>
  context.type === 'riskView' ? { riskViewId: context.riskViewId } : { riskId: context.riskId }
